import CoffeeTimer from "./components/CoffeeTimer";
function App() {
  return <CoffeeTimer minutes={25} />
}
export default App;
